import { Injectable } from '@angular/core';
import { CommonService } from '../common/common.service';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  constructor(private common: CommonService) {}

  async getCaptcha(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.common.ajax({
        url: 'admin/captcha',
        data: {},
        success: (res) => {
          resolve(res);
        },
        fail: (res) => {
          reject(res);
        },
      });
    });
  }

  public validate(value: any, type: string): any {
    let validate = { status: true, msg: '' };
    switch (type) {
      case 'mobile':
        if (value == '' || typeof value == 'undefined') {
          validate = { status: false, msg: '手机号不能为空' };
          break;
        } else if (!/^1[3456789]\d{9}$/.test(value)) {
          validate = { status: false, msg: '手机号格式错误' };
          break;
        }
        break;
      case 'password':
        if (value == '' || typeof value == 'undefined') {
          validate = { status: false, msg: '验证码不能为空' };
        }
        break;
    }
    return validate;
  }

  /**
   * 登陆
   * @param params
   */
  public doLogin(params: object): Promise<any> {
    return new Promise((resolve, reject) => {
      this.common.ajax({
        url: 'admin/login',
        type: 'post',
        loading: true,
        data: params,
        success: (res) => {
          resolve(res);
        },
        fail: (res) => {
          console.log(res);
        },
      });
    });
  }

  /**
   * 发送验证码-星晨管理
   * @param params
   */
  public sendSms(params: object): Promise<any> {
    return new Promise((resolve, reject) => {
      this.common.ajax({
        url: 'admin/sendSms?_allow_anonymous=true',
        type: 'get',
        loading: true,
        data: params,
        success: (res) => {
          resolve(res);
        },
        fail: (res) => {
          console.log(res);
        },
      });
    });
  }

  /**
   * 验证手机号验证码
   * @param params
   */
  public checkMobile(params: object): Promise<any> {
    return new Promise((resolve, reject) => {
      this.common.ajax({
        url: 'admin/checkMobile?_allow_anonymous=true',
        type: 'post',
        loading: true,
        data: params,
        success: (res) => {
          resolve(res);
        },
        fail: (res) => {
          console.log(res);
        },
      });
    });
  }

  /**
   * 修改用户密码
   * @param params
   */
  public changePassword(params: object): Promise<any> {
    return new Promise((resolve, reject) => {
      this.common.ajax({
        url: 'admin/changePassword?_allow_anonymous=true',
        type: 'post',
        loading: true,
        data: params,
        success: (res) => {
          resolve(res);
        },
        fail: (res) => {
          console.log(res);
        },
      });
    });
  }

  /**
   * 手机号登陆（通过验证接口返回的key）
   * @param params
   */
  public loginMobile(params: object): Promise<any> {
    return new Promise((resolve, reject) => {
      this.common.ajax({
        url: 'admin/loginMobile?_allow_anonymous=true',
        type: 'post',
        loading: true,
        data: params,
        success: (res) => {
          resolve(res);
        },
        fail: (res) => {
          console.log(res);
        },
      });
    });
  }

  /**
   * 手机号登陆（通过验证接口返回的key）
   * @param params
   */
  public getWinxinQrcodeUrl(params: object): Promise<any> {
    return new Promise((resolve, reject) => {
      this.common.ajax({
        url: 'admin/getWinxinQrcodeUrl?_allow_anonymous=true',
        type: 'get',
        loading: true,
        data: params,
        success: (res) => {
          resolve(res);
        },
        fail: (res) => {
          console.log(res);
        },
      });
    });
  }

  /**
   * 微信扫码用户点击确认登陆
   * @param params
   */
  public oauth(params: object): Promise<any> {
    return new Promise((resolve, reject) => {
      this.common.ajax({
        url: 'admin/oauth?_allow_anonymous=true',
        type: 'get',
        loading: true,
        data: params,
        success: (res) => {
          resolve(res);
        },
        fail: (res) => {
          console.log(res);
        },
      });
    });
  }

  /**
   * 绑定微信扫码登陆与员工之间的关联关系
   * @param params
   */
  public bindUser(params: object): Promise<any> {
    return new Promise((resolve, reject) => {
      this.common.ajax({
        url: 'admin/bindUser?_allow_anonymous=true',
        type: 'post',
        loading: true,
        data: params,
        success: (res) => {
          resolve(res);
        },
        fail: (res) => {
          console.log(res);
        },
      });
    });
  }

  async getMenuRoles(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.common.ajax({
        url: 'menu/getUserMenu',
        success: (res) => {
          const menu = {};
          for (const i of res) {
            if (i['front_path'] != '') {
              menu[i['front_path']] = [];
            }

            for (const s of i['child_node']) {
              if (s['front_path'] != '') {
                menu[i['front_path']].push(s['front_path']);
              }
            }
          }
          // menu['dormitory'] = ['dormitory-home/test'];
          resolve(menu);
        },
      });
    });
  }
}
